import React from "react";

const BarChartLoader = () => {
  return (
    <div className="bar-chart-loader">
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
      <div className="bar" />
    </div>
  );
};

export default BarChartLoader;
